(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9013],{

/***/ 9633:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/thi-tinh-huong/thi-thu",
      function () {
        return __webpack_require__(19616);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 991:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ HeaderBreadcrumbs; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/lodash/isString.js
var isString = __webpack_require__(47037);
var isString_default = /*#__PURE__*/__webpack_require__.n(isString);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(87357);
// EXTERNAL MODULE: ./node_modules/@mui/material/Stack/Stack.js
var Stack = __webpack_require__(26447);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 2 modules
var Button = __webpack_require__(83321);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/material/Link/Link.js + 1 modules
var Link = __webpack_require__(50122);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/@mui/material/Breadcrumbs/Breadcrumbs.js + 3 modules
var Breadcrumbs = __webpack_require__(12963);
;// CONCATENATED MODULE: ./src/components/Breadcrumbs.js





// next

// @mui

// ----------------------------------------------------------------------
Breadcrumbs_Breadcrumbs.propTypes = {
    activeLast: (prop_types_default()).bool,
    links: (prop_types_default()).array.isRequired
};
function Breadcrumbs_Breadcrumbs(_param) {
    var links = _param.links, _activeLast = _param.activeLast, activeLast = _activeLast === void 0 ? false : _activeLast, other = (0,_object_without_properties/* default */.Z)(_param, [
        "links",
        "activeLast"
    ]);
    var currentLink = links[links.length - 1].name;
    var listDefault = links.map(function(link) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkItem, {
            link: link
        }, link.name);
    });
    var listActiveLast = links.map(function(link) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            style: {
                marginBottom: 5
            },
            children: link.name !== currentLink ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkItem, {
                link: link
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "body2",
                sx: {
                    maxWidth: 260,
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                    color: "text.disabled",
                    textOverflow: "ellipsis"
                },
                textTransform: "inherit",
                children: currentLink
            })
        }, link.name);
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumbs/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        separator: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            component: "span",
            sx: {
                width: 4,
                height: 4,
                borderRadius: "50%",
                bgcolor: "text.disabled"
            }
        }),
        style: {
            alignItems: "center"
        }
    }, other), {
        children: activeLast ? listDefault : listActiveLast
    }));
}
// ----------------------------------------------------------------------
LinkItem.propTypes = {
    link: prop_types_default().shape({
        href: (prop_types_default()).string,
        icon: (prop_types_default()).any,
        name: (prop_types_default()).string
    })
};
function LinkItem(param) {
    var link = param.link;
    var _href = link.href, href = _href === void 0 ? "" : _href, name = link.name, icon = link.icon;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: href,
        passHref: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* default */.Z, {
            variant: "body2",
            sx: {
                lineHeight: 2,
                display: "flex",
                alignItems: "center",
                color: "grey.600",
                "& > div": {
                    display: "inherit"
                }
            },
            textTransform: "inherit",
            children: [
                icon && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    sx: {
                        mr: 1,
                        "& svg": {
                            width: 20,
                            height: 20
                        }
                    },
                    children: icon
                }),
                name
            ]
        }, name)
    });
}

// EXTERNAL MODULE: ./src/components/Iconify.js
var Iconify = __webpack_require__(22554);
;// CONCATENATED MODULE: ./src/components/HeaderBreadcrumbs.js





// @mui

//



// ----------------------------------------------------------------------
HeaderBreadcrumbs.propTypes = {
    links: (prop_types_default()).array,
    subtitle: (prop_types_default()).node,
    heading: (prop_types_default()).string.isRequired,
    moreLink: prop_types_default().oneOfType([
        (prop_types_default()).string,
        (prop_types_default()).array
    ]),
    sx: (prop_types_default()).object
};
function HeaderBreadcrumbs(_param) {
    var links = _param.links, subtitle = _param.subtitle, heading = _param.heading, _moreLink = _param.moreLink, moreLink = _moreLink === void 0 ?  false || [] : _moreLink, sx = _param.sx, other = (0,_object_without_properties/* default */.Z)(_param, [
        "links",
        "subtitle",
        "heading",
        "moreLink",
        "sx"
    ]);
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        sx: (0,_object_spread/* default */.Z)({}, sx),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                spacing: 1,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumbs_Breadcrumbs, (0,_object_spread/* default */.Z)({
                        links: links
                    }, other)),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                        direction: "row",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                sx: {
                                    justifyContent: "flex-start"
                                },
                                startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconify/* default */.Z, {
                                    icon: "fa-solid:arrow-left"
                                }),
                                onClick: function() {
                                    return router.back();
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "h5",
                                component: "h1",
                                textTransform: "uppercase",
                                children: heading
                            })
                        ]
                    }),
                    subtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        sx: {
                            flexShrink: 0,
                            pl: 8
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "body1",
                            children: subtitle
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                sx: {
                    mt: 2
                },
                children: isString_default()(moreLink) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                    href: moreLink,
                    target: "_blank",
                    variant: "body2",
                    children: moreLink
                }) : moreLink.map(function(href) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        noWrap: true,
                        href: href,
                        variant: "body2",
                        target: "_blank",
                        sx: {
                            display: "table"
                        },
                        children: href
                    }, href);
                })
            })
        ]
    });
}


/***/ }),

/***/ 19616:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ SituationExam; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js + 2 modules
var styled = __webpack_require__(11496);
// EXTERNAL MODULE: ./node_modules/@mui/material/Container/Container.js + 1 modules
var Container = __webpack_require__(27948);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(86886);
// EXTERNAL MODULE: ./src/components/Page.js
var Page = __webpack_require__(82771);
// EXTERNAL MODULE: ./src/hooks/useLocales.js + 5 modules
var useLocales = __webpack_require__(9671);
// EXTERNAL MODULE: ./src/hooks/useSettings.js
var useSettings = __webpack_require__(40571);
// EXTERNAL MODULE: ./src/layouts/index.js + 21 modules
var layouts = __webpack_require__(85307);
// EXTERNAL MODULE: ./src/sections/situation/Claimnation.js
var Claimnation = __webpack_require__(6195);
// EXTERNAL MODULE: ./node_modules/@mui/material/Stack/Stack.js
var Stack = __webpack_require__(26447);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(87357);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 2 modules
var Button = __webpack_require__(83321);
// EXTERNAL MODULE: ./node_modules/@mui/material/Card/Card.js + 1 modules
var Card = __webpack_require__(66242);
// EXTERNAL MODULE: ./node_modules/@mui/material/CardContent/CardContent.js + 1 modules
var CardContent = __webpack_require__(44267);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/material/Chip/Chip.js + 2 modules
var Chip = __webpack_require__(87918);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(25617);
// EXTERNAL MODULE: ./src/components/Iconify.js
var Iconify = __webpack_require__(22554);
;// CONCATENATED MODULE: ./src/sections/situationExam/ExamSection.js
/* eslint-disable react/prop-types */ 





// ----------------------------------------------------------------------
function ExamSection(param) {
    var exams = param.exams;
    var getRandomInt = function getRandomInt(min, max) {
        min = Math.ceil(min);
        max = Math.floor(max);
        return Math.floor(Math.random() * (max - min + 1)) + min;
    };
    var router = (0,next_router.useRouter)();
    var random = function() {
        var idx = getRandomInt(0, exams.length - 1);
        var slug = exams[idx].slug;
        router.push("/thi-tinh-huong/thi-thu/".concat(slug));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
        alignItems: "center",
        mb: 2,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
            container: true,
            alignItems: "center",
            px: 2,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        onClick: random,
                        variant: "outlined",
                        size: "medium",
                        sx: {
                            px: 2,
                            py: 1,
                            borderRadius: 1
                        },
                        children: "Đề ngẫu nhi\xean"
                    })
                }),
                exams.map(function(e) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ExamItem, {
                        item: e
                    }, e.id);
                })
            ]
        })
    });
}
function ExamItem(param) {
    var item = param.item;
    var router = (0,next_router.useRouter)();
    var pathname = router.asPath.replace("/thi-tinh-huong/thi-thu/", "").replace("/", "");
    var slug = item.slug, title = item.title;
    var isActive = pathname === slug;
    var exams = (0,es/* useSelector */.v9)(function(state) {
        return state.examS;
    }).exams;
    var exam = exams === null || exams === void 0 ? void 0 : exams.find(function(e) {
        return e.id === item.id;
    });
    var total = exam === null || exam === void 0 ? void 0 : exam.examSituations.map(function(item) {
        return item.score || 0;
    }).reduce(function(a, b) {
        return a + b;
    }, 0);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: "/thi-tinh-huong/thi-thu/".concat(slug),
        passHref: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
            variant: "outlined",
            sx: {
                m: 1,
                cursor: "pointer",
                borderRadius: 1
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent/* default */.Z, {
                sx: {
                    py: 1,
                    px: 2,
                    ":last-child": {
                        paddingBottom: 1
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                    direction: "row",
                    spacing: 1,
                    justifyItems: "center",
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconify/* default */.Z, {
                                icon: "material-symbols:star-rate",
                                style: {
                                    color: isActive ? "orange" : "grey"
                                }
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                            variant: "subtitle2",
                            children: [
                                " ",
                                title
                            ]
                        }),
                        exam && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: total >= 35 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
                                variant: "outlined",
                                label: "ĐẠT",
                                color: "primary",
                                size: "small"
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
                                variant: "outlined",
                                label: "TRƯỢT",
                                color: "error",
                                size: "small"
                            })
                        })
                    ]
                })
            })
        })
    });
}

// EXTERNAL MODULE: ./src/components/HeaderBreadcrumbs.js + 1 modules
var HeaderBreadcrumbs = __webpack_require__(991);
// EXTERNAL MODULE: ./src/routes/paths.js
var paths = __webpack_require__(76939);
;// CONCATENATED MODULE: ./src/sections/situationExam/SituationExamHeader.js
/* eslint-disable react/prop-types */ 




function SituationExamHeader() {
    var translate = (0,useLocales/* default */.Z)().translate;
    var breadcrumbLinks = [
        {
            name: translate("menu.home"),
            href: paths/* PATH_THIGPLX.home */.sH.home
        },
        {
            name: translate("menu.situation"),
            href: paths/* PATH_THIGPLX.situations */.sH.situations
        },
        {
            name: translate("situationExam.title")
        }
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
        spacing: 1,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderBreadcrumbs/* default */.Z, {
            heading: "".concat(translate("situationExam.title"), " ").concat(new Date().getMonth() + 1, "/").concat(new Date().getFullYear()),
            links: breadcrumbLinks,
            subtitle: translate("situationExam.guide")
        })
    });
}

;// CONCATENATED MODULE: ./src/pages/thi-tinh-huong/thi-thu/index.js
/* eslint-disable react/prop-types */ 









var RootStyle = (0,styled/* default */.ZP)("div")(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        paddingTop: theme.spacing(10),
        paddingBottom: theme.spacing(10)
    }, theme.breakpoints.up("md"), {
        paddingTop: theme.spacing(15),
        paddingBottom: theme.spacing(15)
    });
});
SituationExam.getLayout = function getLayout(page) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(layouts/* default */.Z, {
        variant: "main",
        children: page
    });
};
var __N_SSG = true;
function SituationExam(param) {
    var exams = param.exams;
    var translate = (0,useLocales/* default */.Z)().translate;
    var themeStretch = (0,useSettings/* default */.Z)().themeStretch;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Page/* default */.Z, {
        title: translate("situationExam.title"),
        description: translate("situationExam.description"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
            maxWidth: themeStretch ? "xl" : "lg",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(RootStyle, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SituationExamHeader, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        container: true,
                        my: 3,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            xs: 12,
                            md: 12,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ExamSection, {
                                exams: exams
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Claimnation/* default */.Z, {})
                ]
            })
        })
    });
}


/***/ }),

/***/ 6195:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Claimnation; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27948);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26447);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15861);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11496);
/* eslint-disable react/prop-types */ 


// ----------------------------------------------------------------------
var RootStyle = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(style) {
    return {
        marginTop: 20,
        marginBottom: 20,
        padding: 10,
        backgroundColor: style.theme.palette.background.neutral,
        borderRadius: 5
    };
});
function Claimnation() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RootStyle, {
        maxWidth: "xl",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            spacing: 2,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    variant: "subtitle1",
                    color: "primary",
                    children: "LƯU \xdd:"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    variant: "body",
                    children: "✔️ Phần mềm thi thử m\xf4 phỏng 120 t\xecnh huống giao th\xf4ng online của ch\xfang t\xf4i được ph\xe1t triển dựa tr\xean phần mềm offline do Tổng Cục Đường Bộ Việt Nam ban h\xe0nh trước đ\xf3. Nhằm gi\xfap học vi\xean kh\xf4ng c\xf3 m\xe1y t\xednh c\xf3 thể học v\xe0 \xf4n tập trực tiếp tr\xean điện thoại, m\xe1y t\xednh bảng hoặc m\xe1y t\xednh c\xf3 cấu h\xecnh yếu kh\xf4ng đủ điều kiện tải phần mềm."
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    variant: "body",
                    children: "✔️ Đ\xe2y l\xe0 tổng hợp c\xe1c t\xecnh huống với mục đ\xedch kiểm tra nhận thức, phản xạ trước c\xe1c mối nguy hiểm khi tham gia giao th\xf4ng. Đ\xe3 c\xf3 rất nhiều nước ph\xe1t triển tr\xean thế giới như Anh, H\xe0 Lan, \xdac \xe1p dụng phần mềm n\xe0y v\xe0o s\xe1t hạch cấp GPLX v\xe0 mang lại hiệu quả r\xf5 rệt trong việc giảm thiểu số vụ tai nạn giao th\xf4ng."
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    variant: "body",
                    children: "✔️ C\xf3 thể học thuộc v\xe0 nắm r\xf5 120 t\xecnh huống m\xf4 phỏng n\xe0y đồng nghĩa bạn sẽ vượt qua phần thi m\xf4 phỏng 1 c\xe1ch dễ d\xe0ng, kh\xf4ng cần lo lắng. Ngo\xe0i ra, bạn c\xf2n c\xf3 th\xeam c\xe1c kỹ năng phản xạ thực tế khi tham gia giao th\xf4ng sau n\xe0y."
                })
            ]
        })
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5101,1160,6711,3559,9774,2888,179], function() { return __webpack_exec__(9633); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);